import React from 'react'

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Doughnut } from 'react-chartjs-2'
import { FORMAT } from 'utils'

import { Container, LabelContainer, Label } from './styles'

ChartJS.register(ArcElement, Tooltip, Legend)

interface PercentageChartProps {
  backgrounds: [string, string, string]
  values: [number, number, number]
  labels: [string, string, string]
}

const PercentageChart: React.FC<PercentageChartProps> = ({
  values,
  labels,
  backgrounds
}) => {
  const getPercentage = (): string => {
    const mainValue = values[1] // Quantidade de analisados
    const total = values[0] + values[1]

    return FORMAT.percentage(mainValue, total).toFixed(0)
  }

  const valuesExceptTotal = values ? [values[0], values[1], null] : []

  const getMainColor = (): string => {
    const mainColor = backgrounds[1] // Cor dos analisados (Azul)

    return mainColor
  }

  const generateLabelWithValues = (): string[] =>
    values.map((value, index) => `${value} ${labels[index]}`)

  return (
    <Container>
      <LabelContainer>
        {parseInt(getPercentage()) > 0 ? (
          <Label color={getMainColor() || ''}>{`${getPercentage()}%`}</Label>
        ) : null}
      </LabelContainer>
      <Doughnut
        data={{
          datasets: [
            {
              backgroundColor: backgrounds,
              data: valuesExceptTotal,
            }
          ],
          labels: generateLabelWithValues()
        }}
        options={{
          cutout: '80%',
          plugins: {
            datalabels: {
              display: false
            },
            legend: {
              display: true,
              position: 'bottom'
            }
          },
          responsive: true
        }}
      />
    </Container>
  )
}

export default PercentageChart
